module.exports = __webpack_public_path__ + "img/persons.8bf203cf.svg";